import React, { useState, useRef } from "react";
import { SketchPicker } from "react-color";
import { clickOutside } from "../../../reusable/common";

const Color = ({ color = "#000000", onChange, width, height, ...props }) => {
	const [show, setShow] = useState(false);
	const ref = useRef();
	clickOutside(ref, () => setShow(false));

	return (
		<>
			<div className="position-relative">
				<div
					className="box-color"
					style={{ backgroundColor: color }}
					onClick={() => {
						setShow(!show);
					}}
				/>
				{show && (
					<div className="position-absolute sketch-container" ref={ref}>
						<SketchPicker
							color={color}
							onChangeComplete={(color) => {
								onChange(color.hex);
							}}
						/>
					</div>
				)}
			</div>
			<style>{`
                .box-color {
                    width: ${width || "30px"};
                    height: ${height || "30px"};
                    border: 1px solid #C3CDDF;
					cursor: pointer;
                }
                .sketch-container {
                    top: 15px;
                    left: 15px;
                    z-index: 1;
                }
			`}</style>
		</>
	);
};

export default Color;
